import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import type { ReactElement } from 'react';
import { IS_IE } from 'sdk';

import { useSDK } from '../../../../../app';
import { styled } from '../../../../../styled';
import { isMobile } from '../../../../../utils/isMobile';
import { EmojiPickerWrapper } from '../emojiPicker/emojiPickerWrapper';
import { MessageAttachmentIcon } from '../icons/messageAttachmentIcon';
import { BaseInterface, styles } from './common';

type PrechatInterface = BaseInterface & { children: ReactElement };

const Component = observer(
	({
		children,
		className,
		onEmojiPick,
		setShowEmoji,
		emojiPanelActive,
		onAttachmentClick,
		withAttachments = true,
	}: PrechatInterface): ReactElement => {
		const { welcomeDataStore } = useSDK();
		const showEmoji = welcomeDataStore.data?.showcase.useEmoji && setShowEmoji && !isMobile && !IS_IE;
		const showAttaches = welcomeDataStore.data?.showcase.useAttaches && withAttachments;
		const showIcons = showEmoji || showAttaches;
		return (
			<div className={className}>
				{children}
				{showIcons && (
					<div className="btn-group btn-group_column">
						<EmojiPickerWrapper
							active={emojiPanelActive}
							onEmojiPick={onEmojiPick}
							setShowEmoji={setShowEmoji}
						/>
						{welcomeDataStore.data?.showcase.useAttaches && withAttachments ? (
							<MessageAttachmentIcon onClick={onAttachmentClick} />
						) : null}
					</div>
				)}
			</div>
		);
	}
);

export const MessageFieldButtonsPrechat = styled(Component)(
	styles,
	css`
		height: auto;
		width: 100%;

		.btn-group_stretch {
			height: 100%;
			justify-content: space-between;
		}

		& > .btn-group {
			padding: 4px 0;
		}
	`
);
